import {
  ContactType,
  EcommerceContact,
  contactTypes
} from '@/domain/ecommerce-contact'
import { RefundPaymentMethodStrings, RefundTimingsStrings } from '@/utils'

export type OnboardingPlatform =
  | 'Shopify'
  | 'Shopify Plus'
  | 'WooCommerce'
  | 'Prestashop'
  | 'Magento'
  | 'Salesforce'
  | 'LogiCommerce'
  | 'TikTok Shop'
  | 'Custom platform'
  | 'Custom platform v2'
  | 'Inditex'
  | 'Shopware'
  | 'Commerce Layer'
  | undefined

export type BrandInformation = {
  ecommerceName: string
  group?: string
  platform: OnboardingPlatform
  shopifyCollaboratorAccess: string | undefined
  restock: boolean | undefined
  contractsToUse: 'rever' | 'own' | undefined
  tiktokShopId: string | undefined
}

export type WarehouseAddress = {
  email: string
  name: string
  company: string
  phone: string
  country: string
  countryCode: string
  province: string
  city: string
  postcode: string
  addressLine1: string
  addressLine2: string
}

export type RefundMethod =
  | (typeof RefundPaymentMethodStrings)[keyof typeof RefundPaymentMethodStrings]
  | 'EXCHANGE'

export type RefundTiming =
  (typeof RefundTimingsStrings)[keyof typeof RefundTimingsStrings]

export type ReturnConditions = {
  returnDays: number | null
  refundMethods: RefundMethod[]
  timing: RefundTiming
  returnMethods: string[]
  fallbackBankTransfer: boolean | null
  returnsPolicy: string | null
}

export type OnboardingUser = {
  email: string
  name: string
  phone: string
  role: 'admin' | 'user'
  contactTypes: ContactType[]
}

export type DashboardUsers = {
  users: OnboardingUser[]
}

export interface OnboardingInfo {
  brandInformation: BrandInformation
  warehouseAddress: WarehouseAddress
  returnConditions: ReturnConditions
  dashboardUsers: DashboardUsers
}

export type OnboardingAction =
  | { type: 'UPDATE_BRAND_INFORMATION'; payload: BrandInformation }
  | { type: 'UPDATE_WAREHOUSE_ADDRESS'; payload: WarehouseAddress }
  | { type: 'UPDATE_RETURN_CONDITIONS'; payload: ReturnConditions }
  | { type: 'UPDATE_DASHBOARD_USERS'; payload: DashboardUsers }

export function onboardingContacts(
  users: OnboardingUser[]
): EcommerceContact[] {
  return contactTypes.flatMap((type) =>
    users
      .filter((user) => user.contactTypes.includes(type))
      .map((user) => ({
        type,
        email: user.email,
        name: user.name,
        phone: user.phone
      }))
  )
}
